/**
 * This mimics sleep by returning a promise that gets resolved after specified duration
 * @param duration
 * @returns {Promise<unknown>}
 */
export default duration => new Promise(resolve => setTimeout(resolve, duration))
